import { getApiBaseUrl } from '../utils/environment.mjs';
import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

const API_URL = getApiBaseUrl();

const GoogleSignInButton = ({ onSuccess, onError, selectedRegion: _selectedRegion }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSuccess = async (credentialResponse) => {
    setLoading(true);
    try {
      // Decode Google JWT to capture profile before redirecting to Stanford SSO
      const [, payloadB64] = credentialResponse.credential.split('.');
      const googleProfile = JSON.parse(atob(payloadB64));
      sessionStorage.setItem('pendingGoogleProfile', JSON.stringify({
        firstName: googleProfile.given_name || '',
        lastName: googleProfile.family_name || '',
        email: googleProfile.email || '',
        picture: googleProfile.picture || ''
      }));

      const response = await fetch(`${API_URL}/api/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ credential: credentialResponse.credential })
      });

      const data = await response.json();

      if (data.requiresSSO) {
        // ssoUrl is our own backend's SAML initiation route (${BACKEND_URL}/api/auth/stanford).
        // Validate it starts with the known API base URL to prevent open redirect
        // if the API response were ever tampered with.
        if (!API_URL || !data.ssoUrl || !data.ssoUrl.startsWith(API_URL)) {
          if (onError) onError('Authentication error. Please try again.');
          return;
        }
        window.location.href = data.ssoUrl;
        return;
      }

      if (data.success) {
        if (data.needsProfileCompletion) {
          navigate('/complete-profile');
        } else {
          if (onSuccess) onSuccess(data.user);
        }
      } else {
        if (onError) onError(data.message || 'Google authentication failed');
      }
    } catch (error) {
      if (onError) onError('Authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleError = () => {
    if (onError) {
      onError('Google sign-in failed. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-3 px-4 border border-gray-300 rounded-lg bg-white">
        <div className="w-5 h-5 border-2 border-gray-300 border-t-stanford-red rounded-full animate-spin mr-2"></div>
        <span className="text-gray-600">Redirecting to Stanford SSO...</span>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap={false}
        theme="outline"
        size="large"
        text="signin_with"
        shape="rectangular"
        width="100%"
      />
    </div>
  );
};

export default GoogleSignInButton;
